import { render, staticRenderFns } from "./AddBankDetails.vue?vue&type=template&id=2fcfc1b8&"
import script from "./AddBankDetails.vue?vue&type=script&lang=js&"
export * from "./AddBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports